<template>
  <div>
    <div class="contents">
      <table class="table board toggle-xl">
        <thead>
          <tr>
            <th class="col-auto d-none d-xl-table-cell">
              {{ $t("title.common.number") }}
            </th>
            <th class="col-auto d-xl-table-cell">
              {{ $t("title.admin.timezonename") }}
            </th>
            <th class="col-auto d-none d-xl-table-cell">
              {{ $t("title.admin.timezoneoffset") }}
            </th>
            <th class="col-auto d-xl-table-cell">
              {{ $t("title.admin.timezonedstoffset") }}
            </th>
            <th class="col-auto d-none d-xl-table-cell">
              {{ $t("title.common.state") }}
            </th>
            <th class="col-auto d-none d-xl-table-cell">
              {{ $t("title.common.period") }}
            </th>
            <th class="col-auto d-none d-xl-table-cell">
              {{ $t("title.common.registration") }}
            </th>
            <th class="th-arrow"></th>
          </tr>
        </thead>
        <tbody v-if="totalCnt > 0">
          <template v-for="(item, index) in items">
            <tr :key="index">
              <td class="col-auto d-none d-xl-table-cell">{{ item.no }}</td>
              <td class="col-auto d-xl-table-cell">
                <a class="more text-break" @click="goView(index)">{{
                  item.timezone_name
                }}</a>
              </td>
              <td class="col-auto d-none d-xl-table-cell">
                (UTC
                {{
                  item.timezone_offset >= 0
                    ? "+" + item.timezone_offset
                    : item.timezone_offset
                }}:00)
              </td>
              <td class="col-auto d-xl-table-cell">
                {{ item.timezonedst_offset }}
              </td>
              <td class="col-auto d-none d-xl-table-cell">
                {{ item.state }}
              </td>
              <td class="col-auto d-none d-xl-table-cell text-date">
                {{ item.timezone_startdate | dateformat }} ~
                {{ item.timezone_enddate | dateformat }}
              </td>
              <td class="col-auto d-none d-xl-table-cell text-date">
                {{ item.timezone_date | dateformat }}
              </td>
              <td class="td-arrow" @click="toggle_tr(index)">
                <img
                  src="/img/arrow_none_collapsed.png"
                  :class="{ 'btn-toggle-arrow': view_hide === index }"
                />
              </td>
            </tr>
            <tr
              class="d-xl-none"
              :class="{ show: view_hide === index }"
              :key="index + 'r'"
              v-if="view_hide === index"
            >
              <td colspan="7">
                <div class="toggle-content">
                  <div class="row">
                    <div class="col-6">{{ $t("title.common.number") }}</div>
                    <div class="col-6">{{ item.no }}</div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      {{ $t("title.admin.timezoneoffset") }}
                    </div>
                    <div class="col-6">
                      (UTC
                      {{
                        item.timezone_offset >= 0
                          ? "+" + item.timezone_offset
                          : item.timezone_offset
                      }}:00)
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">{{ $t("title.common.state") }}</div>
                    <div class="col-6">{{ item.state }}</div>
                  </div>
                  <div class="row">
                    <div class="col-6">{{ $t("title.common.period") }}</div>
                    <div class="col-6 text-date">
                      {{ item.timezone_startdate | dateformat }} ~
                      {{ item.timezone_enddate | dateformat }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      {{ $t("title.common.registration") }}
                    </div>
                    <div class="col-6 text-date">
                      {{ item.timezone_date | dateformat }}
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="7" class="text-center">
              {{ $t("text.common.no_data") }}
            </td>
          </tr>
        </tbody>
      </table>
      <b-pagination-nav
        :link-gen="linkGen"
        :number-of-pages="pageTotal"
        v-model="searchData.pageno"
        use-router
        :aria-label="$t('text.common.pagination')"
        v-if="pageTotal > 1"
        first-class="prev"
        prev-class="prev"
        next-class="next"
        last-class="next"
        hide-ellipsis
        limit="10"
      >
        <template #first-text
          ><i class="material-icons">keyboard_double_arrow_left</i></template
        >
        <template #prev-text
          ><i class="material-icons">navigate_before</i></template
        >
        <template #next-text
          ><i class="material-icons">navigate_next</i></template
        >
        <template #last-text
          ><i class="material-icons">keyboard_double_arrow_right</i></template
        >
        <template #page="{ page, active }">
          <div v-if="active">{{ page }}</div>
          <div v-else>{{ page }}</div>
        </template>
      </b-pagination-nav>
      <div class="btn-bottom-wrapper">
        <b-button
          size="xl"
          variant="primary"
          :aria-label="$t('button.common.write')"
          @click="$router.push({ path: 'savingtimewrite' })"
          >{{ $t("button.common.write") }}</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import "@/filter/common";
import ax from "@/api/manager";

export default {
  name: "SavingtimeList",
  data() {
    return {
      searchData: {
        startdate:
          this.$route.query.startdate ||
          this.$store.state.searchData.startdate ||
          1,
        enddate:
          this.$route.query.enddate ||
          this.$store.state.searchData.enddate ||
          1,
        pageno:
          this.$route.query.pageno || this.$store.state.searchData.pageno || 1,
      },
      pageTotal: 1,
      totalCnt: 0,
      dataYn: true,
      rows: 10,
      items: [],
      view_hide: null,
    };
  },
  watch: {
    "searchData.startdate": function () {
      this.searchData.pageno = 1;
      this.getList();
    },
    "searchData.enddate": function () {
      this.searchData.pageno = 1;
      this.getList();
    },

    "searchData.pageno": function () {
      this.getList();
    },
  },

  created() {
    this.getList();
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();
      this.searchData.pageno = 1;
      this.$router
        .push({
          name: "ManagerList",
          query: {
            startdate: this.searchData.startdate,
            enddate: this.searchData.enddate,
          },
        })
        .catch(() => {});
    },
    getList() {
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      ax.getTimezonedstList(this.searchData, (flag, data) => {
        if (flag) {
          this.totalCnt = data.listcnt;
          this.pageTotal = Math.ceil(data.listcnt / this.rows);
          this.items = data.list;
        } else {
          this.dataYn = false;
          this.pageTotal = 0;
          alert(data);
        }
      });
    },
    goView(idx) {
      let timezonedst_pk = this.items[idx].timezonedst_pk;
      this.$router.push({
        name: "savingtimeEdit",
        params: { timezonedst_pk: timezonedst_pk },
      });
    },
    linkGen(pageNum) {
      // return pageNum === 1
      //   ? `?searchname=${this.searchData.searchname}&searchtype=${this.searchData.searchtype}`
      //   : `?page=${pageNum}&searchname=${this.searchData.searchname}&searchtype=${this.searchData.searchtype}`
      return `?page=${pageNum}`;
    },
    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
  },
};
</script>